import { render } from "./ControlNumber.vue?vue&type=template&id=6487edf4"
import script from "./ControlNumber.vue?vue&type=script&lang=js"
export * from "./ControlNumber.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__